import { Badge } from 'framework/ui/mui-builder';
import { FieldProps, useFieldHelper } from 'framework/ui/field';
import { ProcessAssetsStatusTypes } from '../../types';
import { PROCESS_ASSETS_STATUS, PROCESS_ASSETS_STATUS_VALUES } from 'domain/gpo/processAssets/constants';

const ProcessAssetsStatusBadgeField = ({ source }: FieldProps) => {
  const { getValue } = useFieldHelper<ProcessAssetsStatusTypes>({ source });

  const status = getValue();

  return (
    <Badge color={status === PROCESS_ASSETS_STATUS.UNPUBLISHED ? 'default' : 'success'}>
      {PROCESS_ASSETS_STATUS_VALUES[status] || PROCESS_ASSETS_STATUS_VALUES.UNPUBLISHED}
    </Badge>
  );
};

export default ProcessAssetsStatusBadgeField;
